export const REQUEST_DELETE_SEGMENT = "request_delete_segment"
export const DELETE_SEGMENT_SUCCESS = "delete_segment_success"
export const DELETE_SEGMENT_FAILURE = "delete_segment_failure"

export const CLEAR_DELETE_SEGMENT_STATES = "clear_delete_segment_states"